<template>
    <mm-tab-title v-model="tab" :titles="titles">
        <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <el-form ref="form" :model="result" size="small" label-width="200px">
            <div v-show="tab===1">
                <el-form-item v-if="edit" label="Offer Id" >
				<mm-get-detail row_type="offer" :row_id="result.offer_id" :row_name="result.offer_id" />
                    <el-input :value="result.offer_id"   readonly />
                </el-form-item>
                <el-form-item label="Channel" >
				<mm-get-detail row_type="channel" :row_id="result.networkid" :row_name="result.network" />
					
                </el-form-item>
                <el-form-item label="Daily Cap" >
                    <el-input type="number" v-model="result.daily_cap"/>
                </el-form-item>
				<el-form-item label="No Block Conv" >
					<el-switch :active-value="1" v-model="result.no_block_conv"/>
				</el-form-item>
				<el-form-item label="Click Cap" >
						<el-input type="number" v-model="result.click_cap"/>
				</el-form-item>
				<el-form-item label="Payout Rate(%)"  >
                    <mm-input-number-percent v-model="result.price_percent" limit_min="0"/>
                </el-form-item>
				<el-form-item label="Deduction Rate(%)"  >
                    <mm-input-number-percent v-model="result.def" limit_min="-3"/>
                </el-form-item>
                <el-form-item label="White" >
					<el-switch v-model="result.white" />
				</el-form-item>
				<el-form-item label="Block Click" >
					<el-switch :active-value="1" v-model="result.block_click" />
				</el-form-item>
				<el-form-item label="Block Conver" >
					<el-switch :active-value="1" v-model="result.block_conv" />
				</el-form-item>
				<el-form-item label="Block Reason" >
					<el-input type="textarea" rows="3" v-model="result.block_reason" />
				</el-form-item>
                
            </div>
            <div v-show="tab===2">
                <mm-channel-subs v-model="result.subs"></mm-channel-subs>
				<el-form-item label="Api Exclude Subs" >
					<el-input type="textarea" rows="3" :value="result.api_exclude_sub" readonly />
				</el-form-item>
            </div>
        </el-form>

    </mm-tab-title>


</template>

<script>

export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
		return {
			result: {
				offer_id:'',
				networkid:'',
				network:'',
			},
			tab: 1,
			titles:['Base Info','Subs Rule'],
		};
	},
	methods: {
		async submit() {
			await this.$validate(this.$refs.form);
			const request_path = this.edit?'/camp/update':'/camp/create';
			const result = await this.$post(request_path,this.result);
			if(this.edit){
				this.loadData();
			}else{
				this.$router.push({ path: "/campEdit",query:{offer_id:result.offer_id,networkid:result.networkid} });
			}
            
		},
		async loadData(){
			if (this.edit) {
				const q= this.$route.query;
				this.result = await this.$post('/camp/detail',q);
			}
		}
	},
    
	beforeMount() {
		this.loadData();
	}
};
</script>